import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import BulkDropZone from "../../commonComponents/bulkDropZone/BulkDropZone.container";
import './BulkJobsList.css';
import _ from 'lodash';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import RemoveBulkModal from "../bulkModal/removeBulkModal/RemoveBulkModal.container";

class BulkJobsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            bulkToRemove: null
        }
    }

    render() {
        if (this.props.signingKeyLoading || this.props.orgLoading) {
            return (
                <div className="bulk-jobs-list-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (this.props.isSigningRequired && _.isNil(this.props.signingKey)) {
            return (
                <div>
                    <h4 className="page-label">{_.get(this.props.translation, 'bulk_jobs_list.label')}</h4>
                    <div className="carrot-red">
                        {_.get(this.props.translation, "insert_accreditation.no_certificate_message_start")}
                        <a href="/security">
                            {_.get(this.props.translation, "insert_accreditation.no_certificate_message_link")}
                        </a>
                        {_.get(this.props.translation, "insert_accreditation.no_certificate_message_end")}
                    </div>
                </div>
            );
        }

        return (
            <div className='bulk-jobs-list-container'>
                <h4 className="page-label">
                    {_.get(this.props.translation, 'bulk_jobs_list.label')}
                </h4>
                <BulkDropZone/>               
                {this.renderContent()}
                <RemoveBulkModal data={this.state.bulkToRemove} onCancelRemoving={this.props.onCancelRemoving}/>
            </div>
        );
    }

    renderContent() {
        if (this.props.loading && (_.isNil(this.props.data) || _.isEmpty(this.props.data))) {
            return (
                <div className="bulk-jobs-list-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || _.isEmpty(this.props.data)) {
            return (
                <div className="bulk-jobs-list-message-container">
                    <h5>{_.get(this.props.translation, 'bulk_jobs_list.no_data_message')}</h5>
                </div>
            );
        }
        return (
            <Table className='jobs-data-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.file_name_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.created_at_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.processed_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.status_label')}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderJobsData()}
                </tbody>
            </Table>
        );
    }

    renderJobsData() {
        return _.map(this.props.data, (jobData) => (
            <tr key={jobData.id}
                className={'jobs-data-row ' + (!_.isEmpty(jobData.errors) || jobData.globalError ? 'has-errors' : '')}
                title={this.getTitle(jobData)}>
                <td className='file-name-td' data-th={_.get(this.props.translation, 'bulk_jobs_list.file_name_label') + ":"}>{jobData.fileName}</td>
                <td className='created-at-td' data-th={_.get(this.props.translation, 'bulk_jobs_list.created_at_label')+ ":"}>{jobData.createdAt}</td>
                <td className='processed-td' data-th={_.get(this.props.translation, 'bulk_jobs_list.processed_label')+ ":"}>
                    {jobData.processedPersent}% ({jobData.processedEntriesCount}/{jobData.totalEntriesCount})
                </td>
                <td className='status-td' data-th={_.get(this.props.translation, 'bulk_jobs_list.status_label')+ ":"}>{this.getStatus(jobData)}</td>
                <td className='control-cell bulk-controls'>
                    {jobData.finished ? (
                        <IconContainer
                            className="job-remove-icon"
                            icon='trash'
                            title={_.get(this.props.translation, 'bulk_jobs_list.remove_bulk_button')}
                            onClick={this.handleRemoveBulk(jobData)}
                        />
                    ) : null}
                </td>
            </tr>
        ));
    }

    getStatus = (jobData) => {
        let className;
        let labelPath;
        if (jobData.finished) {
            if (jobData.globalError) {
                className = 'error-label';
                labelPath = 'bulk_jobs_list.error_label';
            } else {
                className = 'finished-label';
                labelPath = 'bulk_jobs_list.finished_label';
            }
        } else {
            className = 'in-progress-label';
            labelPath = 'bulk_jobs_list.in_progress_label';
        }

        return (<span className={className}>{_.get(this.props.translation, labelPath)}</span>)
    };

    getTitle = (jobData) => {
        return jobData.globalError ? _.get(this.props.translation, 'bulk_jobs_list.global_error_label') : jobData.errors.join('.\n');
    };

    componentDidMount() {
        this.props.onLoadJobs();
        this.props.onGetOrganization();
    }

    componentWillReceiveProps(nextProps) {
        this.fetchJobsListTimeout(nextProps.data);
    }

    componentWillUpdate(nextProps) {
        if (!_.isNil(nextProps.group) && nextProps.group !== this.props.group) {
            this.props.onLoadJobs();
        }
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    fetchJobsListTimeout(jobsData) {
        if (!_.isEmpty(jobsData) && _.some(jobsData, job => !job.finished) && _.isNil(this.timeout)) {
            this.timeout = setTimeout(
                () => {
                    this.props.onLoadJobs();
                    this.timeout = null;
                },
                5000
            );
        }
    }

    handleRemoveBulk = (bulkData) => () => {
        this.props.onRemoveBulk();
        this.setState({
            bulkToRemove: bulkData
        })
    }
}


BulkJobsList.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    signingKey: PropTypes.object,
    signingKeyLoading: PropTypes.bool,
    isSigningRequired: PropTypes.bool,
    translation: PropTypes.object,
    onLoadJobs: PropTypes.func,
    onRemoveBulk: PropTypes.func,
    onCancelRemoving: PropTypes.func
};

export default BulkJobsList;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/bulkJobsList/BulkJobsList.js